export default __webpack_public_path__ + "static/Lato-Black-0b51cf32bbc2d8b8d840c80c77a84a31.ttf";